import { Link } from "react-router-dom";
import { createPortal } from "react-dom";

const colHeading = {
  fontFamily: "'DM Sans', sans-serif", fontSize: 11, fontWeight: 700, letterSpacing: "0.12em",
  textTransform: "uppercase", color: "#9A9A9A", marginBottom: 16, marginTop: 0,
};

const locationsWithImages = [
  { name: "Manchester", path: "/management/manchester/", image: "https://media.base44.com/images/public/6a316287a1be7d9945ac7d10/9f3ae319c_dinosaur-manchester-skyline-1186.webp" },
  { name: "Liverpool", path: "/management/liverpool/", image: "https://media.base44.com/images/public/6a316287a1be7d9945ac7d10/954ece74d_Liverpool.jpg" },
  { name: "Stoke-on-Trent", path: "/management/stoke-on-trent/", image: "https://media.base44.com/images/public/6a316287a1be7d9945ac7d10/7b53d04b6_StreoAd-260x2004.jpg" },
  { name: "Birmingham", path: "/management/birmingham/", image: "https://media.base44.com/images/public/6a316287a1be7d9945ac7d10/54b1e7e77_Birmingham.jpg" },
  { name: "London", path: "/management/london/", image: "https://media.base44.com/images/public/6a316287a1be7d9945ac7d10/82fcfda27_generated_image.png" },
];

const locationsListOnly = [
  { name: "Newcastle", path: "/management/newcastle/" },
  { name: "Leeds", path: "/management/leeds/" },
  { name: "Southampton", path: "/management/southampton/" },

  { name: "Sheffield", path: "/management/sheffield/" },
  { name: "Stockport", path: "/management/stockport/" },
  { name: "Brighton", path: "/management/brighton/" },
  { name: "Essex", path: "/management/essex/" },
  { name: "Oxford", path: "/management/oxford/" },
  { name: "Bath", path: "/management/bath/" },
  { name: "Slough", path: "/management/slough/" },
  { name: "Bristol", path: "/management/bristol/" },
];

export default function LocationsMegaMenu({ onClose, onMouseEnter, onMouseLeave }) {
  return createPortal(
    <>
      <div
        style={{ position: "fixed", inset: 0, top: "calc(68px + var(--ts-promo-height, 0px))", background: "linear-gradient(to bottom, transparent 0%, rgba(0,0,0,0.45) 100%)", zIndex: 150, animation: "fadeIn 0.2s ease" }}
        onMouseEnter={onMouseLeave}
      />
      <div
        style={{ position: "fixed", top: "calc(68px + var(--ts-promo-height, 0px))", left: 0, right: 0, zIndex: 300 }}
        onMouseEnter={onMouseEnter}
        onMouseLeave={onMouseLeave}
        className="locations-mega-menu"
      >
        <div style={{ maxWidth: 1200, margin: "0 auto", padding: "0 clamp(20px, 5vw, 80px)" }}>
          <div style={{ background: "white", borderRadius: "18px 18px 18px 18px", boxShadow: "0 20px 48px -12px rgba(0,0,0,0.22)", overflow: "hidden", animation: "megaSlideDown 0.2s ease" }}>
            <div style={{ padding: "24px 32px" }}>
              <p style={{ ...colHeading, marginBottom: 20 }}>Our Locations</p>

              <div style={{ display: "grid", gridTemplateColumns: "repeat(5, 1fr)", gap: 12, marginBottom: 28 }} className="mega-menu-grid">
                {locationsWithImages.map((loc) => (
                  <Link key={loc.name} to={loc.path} onClick={onClose}
                    style={{ display: "block", textDecoration: "none", borderRadius: 14, overflow: "hidden", position: "relative", aspectRatio: "1 / 1", transition: "transform 0.2s, box-shadow 0.2s" }}
                    onMouseEnter={e => { e.currentTarget.style.transform = "translateY(-3px)"; e.currentTarget.style.boxShadow = "0 10px 28px rgba(0,0,0,0.18)"; }}
                    onMouseLeave={e => { e.currentTarget.style.transform = "translateY(0)"; e.currentTarget.style.boxShadow = "none"; }}>
                    <img src={loc.image} alt={loc.name} style={{ width: "100%", height: "100%", objectFit: "cover", display: "block", position: "absolute", inset: 0 }} />
                    <div style={{ position: "absolute", inset: 0, background: "linear-gradient(to top, rgba(0,0,0,0.65) 0%, rgba(0,0,0,0.05) 55%, transparent 100%)" }} />
                    <div style={{ position: "absolute", bottom: 0, left: 0, right: 0, padding: "12px 14px" }}>
                      <p style={{ fontFamily: "'DM Sans', sans-serif", fontWeight: 700, fontSize: 14, color: "#fff", margin: 0, letterSpacing: "-0.01em" }}>{loc.name}</p>
                      <p style={{ fontFamily: "'DM Sans', sans-serif", fontSize: 11, color: "rgba(255,255,255,0.7)", margin: "2px 0 0" }}>View →</p>
                    </div>
                  </Link>
                ))}
              </div>

              {locationsListOnly.length > 0 && (
                <div>
                  <p style={colHeading}>More Locations</p>
                  <div style={{ display: "flex", gap: 4, flexWrap: "wrap" }}>
                    {locationsListOnly.map((loc) => (
                      <Link key={loc.name} to={loc.path} onClick={onClose}
                        style={{ fontFamily: "'DM Sans', sans-serif", fontWeight: 600, fontSize: 14, color: "#1A1A1A", textDecoration: "none", padding: "8px 10px", borderRadius: 8, transition: "background 0.15s" }}
                        onMouseEnter={e => e.currentTarget.style.background = "#F7F7F5"}
                        onMouseLeave={e => e.currentTarget.style.background = "transparent"}>
                        {loc.name}
                      </Link>
                    ))}
                    <Link to="/locations" onClick={onClose}
                      style={{ fontFamily: "'DM Sans', sans-serif", fontWeight: 600, fontSize: 14, color: "#1A1A1A", textDecoration: "none", padding: "8px 10px", borderRadius: 8, transition: "background 0.15s" }}
                      onMouseEnter={e => e.currentTarget.style.background = "#F7F7F5"}
                      onMouseLeave={e => e.currentTarget.style.background = "transparent"}>
                      See All →
                    </Link>
                  </div>
                </div>
              )}
            </div>
          </div>
        </div>
        <style>{`
          @media (max-width: 768px) { .mega-menu-grid { grid-template-columns: repeat(2, 1fr) !important; } }
          @media (min-width: 769px) and (max-width: 1000px) { .mega-menu-grid { grid-template-columns: repeat(3, 1fr) !important; } }
          @media (min-width: 1001px) and (max-width: 1200px) { .mega-menu-grid { grid-template-columns: repeat(4, 1fr) !important; } }
          @media (min-width: 1201px) { .mega-menu-grid { grid-template-columns: repeat(5, 1fr) !important; } }
          @keyframes fadeIn { from { opacity: 0; } to { opacity: 1; } }
          @keyframes megaSlideDown { from { opacity: 0; transform: translateY(-10px); } to { opacity: 1; transform: translateY(0); } }
        `}</style>
      </div>
    </>,
    document.body
  );
}